import { styled } from '@mui/material';
import { ChangeEventHandler, useContext } from 'react';
import { ImagesContext } from '../../contexts/ImagesContext';
import { ImageType } from '../../utils/image';
import config from '../../config';

const Input = styled('input')({
  display: 'none',
});

type InputImageHandler = (url: string) => void;

type InputImageProps = {
  id: string,
  isDisabled: boolean,
  fileHandler: InputImageHandler,
  type: ImageType,
  onMaxFileSizeExceeded?: (message: string) => void,
  setIsLoading?: (isLoading: boolean) => void,
};

function InputImage({
  id, isDisabled, fileHandler, type, onMaxFileSizeExceeded, setIsLoading,
}: InputImageProps) {
  const { Create } = useContext(ImagesContext);

  const handleFiles: ChangeEventHandler<HTMLInputElement> = (event) => {
    if (setIsLoading) setIsLoading(true);
    onMaxFileSizeExceeded('');
    const { files } = event.currentTarget;

    if (!files || files?.length === 0) return;
    const file = files[0];
    if (!file.type.includes('image/')) {
      event.currentTarget.value = '';
      if (setIsLoading) setIsLoading(false);
      return;
    }

    if (file.size > config.image.maxFileSize) {
      if (onMaxFileSizeExceeded) {
        onMaxFileSizeExceeded(`画像ファイルサイズは${config.image.maxFileSizeInMb}MB以下にしてください。`);
      }
      event.currentTarget.value = '';
      if (setIsLoading) setIsLoading(false);
      return;
    }

    // upload to server and generate url
    const fileReaderForBinary = new FileReader();
    fileReaderForBinary.onload = () => {
      const res = fileReaderForBinary.result as ArrayBuffer;
      Create(res, type)
        .then(({ url }) => {
          const imageUrl = `${process.env.REACT_APP_API_URL}/${url}`;
          fileHandler(imageUrl);
        }).finally(() => {
          if (setIsLoading) setIsLoading(false);
        });
    };
    fileReaderForBinary.readAsArrayBuffer(file);
    event.currentTarget.value = ''; // TODO: check if there's a better way to do this
  };

  return (
    <Input disabled={isDisabled} accept="image/*" id={id} multiple type="file" onChange={(e) => { handleFiles(e); }} />
  );
}

export default InputImage;
